<!--价格管理-快捷销售定价 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input size="medium" v-model="searchForm.PRODUCT_CODE" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.TC_COMPANY" placeholder="请选择客户" :clearable="true">
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报价分组：">
            <el-select size="medium" filterable v-model="searchForm.AREA_ID" placeholder="请选择分组" :clearable="true">
              <el-option v-for="item in priceGroup" :key="item.ID" :label="item.CLIENT_AREA"
                :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-button size="medium" type="primary" @click="doQueryTable()">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" v-if="userPriceType == 1" @click="batchUpdateData()">批量修改</el-button>
        <el-button size="medium" v-if="userPriceType == 1" @click="batchDel()">删除</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table @selection-change="handleSelectionChange" border stripe :data="tableData" style="margin-top: 20px">
          <el-table-column type="selection" width="55" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="产品名称" prop="PRODUCT_NAME"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="客户" prop="TC_NAME"></el-table-column>
          <el-table-column label="价格" prop="PRICE" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="开始日期" prop="START_DAY" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="结束日期" prop="END_DAY" v-if="userPriceType == 2"></el-table-column>
          <el-table-column label="当期价格" prop="CURRENT_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期价格" prop="NEXT_PRICE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="下期生效日期" prop="NEXT_EFFECTIVE_DATE" v-if="userPriceType == 1"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="updateData(scope.row)">修改价格</el-button>
              <el-button size="small" type="text" @click="delData(scope.row)" v-if="userPriceType == 1">删除</el-button>
              <!-- <el-button size="small" type="text" @click="downData(scope.row)" v-if="tcStatus === 1 && userPriceType == 1" disabled>删除</el-button> -->
              <el-button size="small" type="text" @click="downData(scope.row)" v-if="userPriceType == 2">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <div class="pagination_box" v-show="total_count > 10">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </div>
    <el-dialog title="修改" center :visible.sync="editFormVisible" width="500px">
      <el-form :model="editForm" ref="editForm" style="margin-top: 0">
        <div v-if="userPriceType == 1">
          <el-form-item label="价格：" :label-width="formLabelWidth" prop="leader">
            <label slot="label">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格：</label>
            <el-input v-model="editForm.CURRENT_PRICE" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <label slot="label">生效日期：</label>
            <el-date-picker v-model="editForm.SEND_DAY" :clearable="false" :picker-options="pickerOptions" type="date"
              placeholder="选择日期" style="width: 100%">
            </el-date-picker>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="价格：" :label-width="formLabelWidth" prop="leader">
            <label slot="label">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格：</label>
            <el-input v-model="editForm.PRICE" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <label slot="label">开始日期：</label>
            <el-date-picker v-model="editForm.START_DAY" :clearable="false" :picker-options="pickerOptions"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <label slot="label">结束日期：</label>
            <el-date-picker v-model="editForm.END_DAY" :clearable="false" :picker-options="pickerOptions"
              format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <label slot="label">客户编码：</label>
            <el-input v-model="editForm.TC_PRODUCT_CODE"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth">
            <label slot="label">换算比例：</label>
            <el-input v-model="editForm.CHANGE_RATE"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('editForm')">取 消</el-button>
        <el-button v-if="type == 1" @click="submitAdd('editForm')">确 定</el-button>
        <el-button v-if="type == 2" @click="batchEditPrice('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { selectTCFun } from 'api/sellOrder';
import { getPriceGroupFun, querySalePricing } from 'api/systemSetting';
import http from '@/assets/common/http';
import date from '@/assets/common/date';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      total_count: 0,
      pageSize: 10,
      currentPage: 1,
      companys: [],
      priceGroup: [],
      dataList: [],
      editFormVisible: false,
      editForm: {
        SEND_DAY: new Date(),
      },
      pickerOptions: {
        disabledDate(time) {
          const nowD = new Date();
          return time.getTime() < nowD.getTime() - 3600 * 24 * 1000;
        },
      },
      formLabelWidth: '100px',
      type: '',
      userPriceType: sessionStorage.getItem('PRICE_MODE'),
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SALE_PRICING_CONDITION) {
      this.currentPage = this.SALE_PRICING_CONDITION.CURRENT_PAGE;
      this.searchForm = this.SALE_PRICING_CONDITION.CONDITION;
      this.queryData();
    } else {
      this.currentPage = 1;
    }
    this.getPriceGroupFun();
    this.queryCustomer();
  },
  computed: {
    SALE_PRICING_CONDITION() {
      return this.$store.state.SALE_PRICING_CONDITION;
    },
  },
  methods: {
    // 选择客户
    queryCustomer() {
      selectTCFun()
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].company;
          } else {
            this.companys = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 报价分组
    getPriceGroupFun() {
      getPriceGroupFun()
        .then((result) => {
          this.priceGroup = result;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 筛选
    doQueryTable() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      if (!validation.产品编码验证(this.searchForm.PRODUCT_CODE)) {
        this.$message.show({ text: '产品编码输入有误', type: 'warning' });
        return false;
      }
      const params = {
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
        PRICE_MODE: Number(sessionStorage.getItem('PRICE_MODE')),
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.AREA_ID) {
        params.AREA_ID = this.searchForm.AREA_ID;
      }
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      querySalePricing(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].LIST;
            this.total_count = result[0].TOTAL_COUNT;
            this.$store.dispatch('SET_SALE_PRICING_CONDITION', {
              CURRENT_PAGE: this.currentPage,
              CONDITION: this.searchForm,
              DATA: this.tableData,
              TOTAL_COUNT: this.total_count,
            });
          } else {
            this.tableData = [];
            this.total_count = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 修改价格
    // -----------------------修改
    updateData(row) {
      this.type = 1;
      this.editFormVisible = true;
      this.editForm = row;
    },
    submitAdd() {
      console.log(this.editForm, '8888888888888888');
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 11,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: this.editForm.TC_ID,
        PRODUCT_CODE: this.editForm.PRODUCT_CODE,
        EFFECTIVE_DAY: date(this.editForm.SEND_DAY, '%F'),
        PRICE_MODE: Number(sessionStorage.getItem('PRICE_MODE')),
      };
      if (this.userPriceType == 2) {
        params.START_DAY = this.editForm.START_DAY;
        params.END_DAY = this.editForm.END_DAY;
        params.TC_PRODUCT_CODE = this.editForm.TC_PRODUCT_CODE;
        params.CHANGE_RATE = this.editForm.CHANGE_RATE;
        params.DETAIL_ID = this.editForm.ID;
        params.PRICE = Number(this.editForm.PRICE);
      } else {
        params.PRICE = Number(this.editForm.CURRENT_PRICE);
      }
      http.post(params)
        .then((result) => {
          this.queryData();
          this.editFormVisible = false;
          this.editForm = {};
          this.$message.show({ text: '修改成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    close() {
      this.editFormVisible = false;
      this.batchDownShelfFormVisible = false;
    },
    // 删除
    downData(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10041',
          OTYPE: 32,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: Number(row.TC_ID),
          DETAIL_ID: row.ID,
          PRODUCT_CODE: row.PRODUCT_CODE,
          START_DAY: row.START_DAY,
          END_DAY: row.END_DAY,
        };
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ text: '操作取消', type: 'info' });
      });
    },
    delData(row) {
      this.$confirm('确定下架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '10041',
          OTYPE: 8,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: Number(row.TC_ID),
          PRODUCT_CODE: row.PRODUCT_CODE,
          DETAIL_ID: row.ID,
        };
        http.post(params)
          .then((result) => {
            this.$message.show({ text: '下架成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ text: '操作取消', type: 'info' });
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // 多选
    handleSelectionChange(val) {
      const dataList = [];
      val.forEach((item) => { dataList.push(item); });
      this.dataList = dataList;
      console.log(this.dataList, '选中的数据');
    },
    batchUpdateData() {
      this.type = 2;
      this.editFormVisible = true;
    },
    // 批量修改
    async batchEditPrice() {
      if (this.dataList.length == 0) {
        this.$message.show({ text: '请勾选需要修改的产品', type: 'warning' });
        return;
      }
      const paramsList = [];
      const resList = [];
      const erroeList = [];
      let flag = 0;
      this.dataList.forEach((item, index) => {
        paramsList.push({
          SERVICE_ID: '10041',
          OTYPE: 11,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: item.TC_ID,
          PRODUCT_CODE: item.PRODUCT_CODE,
          PRICE_MODE: Number(sessionStorage.getItem('PRICE_MODE')),
          EFFECTIVE_DAY: date(this.editForm.SEND_DAY, '%F'),
        });
      });
      if (this.userPriceType == 2) {
        paramsList.forEach((item, index) => {
          // item.EFFECTIVE_DAY = this.editForm.START_DAY,
          item.START_DAY = this.editForm.START_DAY;
          item.END_DAY = this.editForm.END_DAY;
          item.TC_PRODUCT_CODE = this.editForm.TC_PRODUCT_CODE;
          item.CHANGE_RATE = this.editForm.CHANGE_RATE;
          item.DETAIL_ID = this.editForm.ID;
          item.PRICE = Number(this.editForm.PRICE);
        });
      } else {
        paramsList.forEach((item, index) => {
          item.PRICE = Number(this.editForm.CURRENT_PRICE);
        });
      }
      for (const item of paramsList) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const res = await http.post(item);
          resList.push(res);
        } catch (e) {
          erroeList.push(e);
        }
      }
      if (erroeList.length !== 0) {
        flag = 2;
        console.log(erroeList);
      }
      if (flag == 0) {
        this.editFormVisible = false;
        this.editForm = {};
        this.$message.show({ text: '批量修改成功', type: 'success' });
      } else {
        let errText = '';
        let newArr = new Set(erroeList);
        newArr = Array.from(newArr);
        for (const item of newArr) {
          errText = `${item},${errText}`;
        }
        this.$message.show({ text: errText, type: 'error' });
      }
      this.queryData();
    },
    // 批量删除
    async batchDel() {
      if (this.dataList.length == 0) {
        this.$message.show({ text: '请勾选需要删除的产品', type: 'warning' });
        return;
      }
      const paramsList = [];
      const resList = [];
      const erroeList = [];
      let flag = 0;
      this.dataList.forEach((item, index) => {
        paramsList.push({
          SERVICE_ID: '10041',
          OTYPE: 8,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: Number(item.TC_ID),
          PRODUCT_CODE: item.PRODUCT_CODE,
          DETAIL_ID: item.ID,

        });
      });
      for (const item of paramsList) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const res = await http.post(item);
          resList.push(res);
        } catch (e) {
          erroeList.push(e);
        }
      }
      if (erroeList.length !== 0) {
        flag = 2;
        console.log(erroeList);
      }
      if (flag == 0) {
        this.$message.show({ text: '批量删除成功', type: 'success' });
      } else {
        let errText = '';
        let newArr = new Set(erroeList);
        newArr = Array.from(newArr);
        for (const item of newArr) {
          errText = `${item},${errText}`;
        }
        this.$message.show({ text: errText, type: 'error' });
      }
      this.queryData();
    },
  },
};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/expressSalePricing.vue